
var fileLoadingImage = "https://cdn.allmoxy.com/mrp/images/loading.gif";
var fileBottomNavCloseImage = "https://cdn.allmoxy.com/mrp/images/closelabel.png";
var noimagefound = "https://cdn.allmoxy.com/brading/defaultimage.jpeg";  //IN CASE NO IMAGE IS FOUND
var resizeSpeed = 8; // controls the speed of the image resizing (1=slowest
						// and 10=fastest)
var borderSize = 10; // if you adjust the padding in the CSS, you will need
						// to update this variable

var site;

var imageArray = new Array;
var activeImage;

if (resizeSpeed > 10) {
	resizeSpeed = 10;
}
if (resizeSpeed < 1) {
	resizeSpeed = 1;
}
resizeDuration = (11 - resizeSpeed) * 100;

Object.extend(Element, {
	hide : function() {
		for ( var i = 0; i < arguments.length; i++) {
			var element = $(arguments[i]);
			element.style.display = 'none';
		}
	},
	show : function() {
		for ( var i = 0; i < arguments.length; i++) {
			var element = $(arguments[i]);
			element.style.display = '';
		}
	},
	getWidth : function(element) {
		element = $(element);
		return element.offsetWidth;
	},
	setWidth : function(element, w) {
		element = $(element);
		element.style.width = w + "px";
	},
	getHeight : function(element) {
		element = $(element);
		return element.offsetHeight;
	},
	setHeight : function(element, h) {
		element = $(element);
		element.style.height = h + "px";
	},
	setTop : function(element, t) {
		element = $(element);
		element.style.top = t + "px";
	},
	setSrc : function(element, src) {
		element = $(element);
		element.src = src;
	},
	setInnerHTML : function(element, content) {
		element = $(element);
		element.innerHTML = content;
	}
});

Array.prototype.removeDuplicates = function() {
	for (i = 1; i < this.length; i++) {
		if (this[i][0] == this[i - 1][0]) {
			this.splice(i, 1);
		}
	}
}

Array.prototype.empty = function() {
	for (i = 0; i <= this.length; i++) {
		this.shift();
	}
}

var Lightbox = Class.create();

Lightbox.litebox_nav_allowed = function() {
	var activator_pao = Lightbox.activatedBy && Lightbox.activatedBy.up('.pao_pic');
	return !(activator_pao && activator_pao.getAttribute('data-no_litebox_nav') == 1);
};

Lightbox.prototype = {
	initialize_more : function(container){
		var anchors = $(container).select('a');
		for ( var i = 0; i < anchors.length; i++) {
			var anchor = anchors[i];
			var relAttribute = String(anchor.getAttribute('rel'));
			// DEV-13574: "bound" is a JS property, not the data attribute. Callers strip the
			// attribute to force a rebind (cloned rows copy it without the handler), which
			// stacked one more click handler per order_item_changed - a click then ran
			// start() N times. Clones never copy the property, so they still get bound.
			if (anchor.getAttribute('href') && (relAttribute.toLowerCase().match('lightbox')) && !anchor._liteboxBound) {
				anchor._liteboxBound = true;
				anchor.setAttribute('data-litebox_initialized', 1);
				$(anchor).observe('click', function(ev) {
					ev.stop();
					initLightbox.myLightbox.start(this);
				});
			}
		}
	},
	initialize : function() {
		if (!document.getElementsByTagName)
			return;
		var anchors = document.getElementsByTagName('a');
		for ( var i = 0; i < anchors.length; i++) {
			var anchor = anchors[i];
			var relAttribute = String(anchor.getAttribute('rel'));
			if (anchor.getAttribute('href')
					&& (relAttribute.toLowerCase().match('lightbox'))) {
				anchor.onclick = function() {
					initLightbox.myLightbox.start(this);
					return false;
				}
			}
		}

		var objBody = Element.extend(document.getElementsByTagName("body").item(0));
		objBody.insert(new Element('div',{'id':'overlay'})
			.observe('click',function(ev) {initLightbox.myLightbox.end();ev.stop();}));

		var objLightbox = new Element('div',{'id':'lightbox'}).setStyle({'display':'none'});
		objLightbox.observe('click', function(ev) {
			if (this == ev.element()) {
				initLightbox.myLightbox.end();
				ev.stop();
			}
		});
		objBody.insert(objLightbox);

		var objOuterImageContainer = new Element('div',{'id':'outerImageContainer'});
		objLightbox.insert(objOuterImageContainer)
		.insert(new Element('div',{'id':'imageDataContainer'}).addClassName('clearfix')
				.insert(new Element('div',{'id':'imageData'})
					.insert(new Element('div',{'id':'imageDetails'})
						.insert(new Element('span',{'id':'caption'}))
						.insert(new Element('span',{'id':'numberDisplay'})))
					.insert(new Element('div',{'id':'bottomNav'})
						.insert(new Element('a',{'id':'bottomNavClose',href:'javascript:void(0);'})
							.observe('click',function(ev) {initLightbox.myLightbox.end();ev.stop();})
							.insert(new Element('img',{'src':fileBottomNavCloseImage}))))));

		var objImageContainer = new Element('div',{'id':'imageContainer'});
		objOuterImageContainer.insert(objImageContainer);

		objImageContainer.insert(new Element('img',{'id':'lightboxImage'}))
		.insert(new Element('div',{'id':'hoverNav'})
			.insert(new Element('a',{'id':'prevLink',href:'javascript:void(0);'}))
			.insert(new Element('a',{'id':'nextLink',href:'javascript:void(0);'}))
			.insert(new Element('a',{'id':'selectLink',href:'javascript:void(0);'})))
		.insert(new Element('div',{'id':'lb_ld'})
			.insert(new Element('a',{'id':'loadingLink',href:'javascript:void(0);'})
				.observe('click',function(ev) {initLightbox.myLightbox.end();ev.stop();}))
				.insert(new Element('img',{'src':fileLoadingImage})));

		overlayEffect = new fx.Opacity($('overlay'), {
			duration :300
		});
		overlayEffect.hide();

		imageEffect = new fx.Opacity($('lightboxImage'), {
			duration :350,
			onComplete : function() {
				imageDetailsEffect.custom(0, 1);
			}
		});
		imageEffect.hide();

		imageDetailsEffect = new fx.Opacity($('imageDataContainer'), {
			duration :400,
			onComplete : function() {
				navEffect.custom(0, 1);
			}
		});
		imageDetailsEffect.hide();

		navEffect = new fx.Opacity($('hoverNav'), {
			duration :100
		});
		navEffect.hide();
	},

	start : function(imageLink) {
		Lightbox.activatedBy = $(imageLink);
		hideSelectBoxes();
		var arrayPageSize = getPageSize();
		// With default style "height: 100%" this is unneccessary; it was also causing scrollbars to be added
		// to element <HTML> if viewport was smaller than the previous or initial height of #overlay.
		// (Improvement could be made by adding a viewport resize listener to resize #lightbox.)
		//Element.setHeight('overlay', arrayPageSize[1]);
		overlayEffect.custom(0, 0.8);
	    site = imageLink.toString().substring(0,imageLink.toString().indexOf('data'));  //Update global Variable
		imageArray = [];
		imageNum = 0;

		if (!document.getElementsByTagName) {
			return;
		}
		var anchors = document.getElementsByTagName('a');

		if ((imageLink.getAttribute('rel') == 'lightbox')) {

			imageArray.push(new Array(imageLink.getAttribute('href'), imageLink
					.getAttribute('title')));
		} else {

			for ( var i = 0; i < anchors.length; i++) {
				var anchor = anchors[i];
				if (anchor.getAttribute('href')
						&& (anchor.getAttribute('rel') == imageLink
								.getAttribute('rel'))) {
					imageArray.push(new Array(anchor.getAttribute('href'),
							anchor.getAttribute('title')));
				}
			}
			imageArray.removeDuplicates();
			while (imageArray[imageNum][0] != imageLink.getAttribute('href')) {
				imageNum++;
			}
		}

		var arrayPageSize = getPageSize();
		var arrayPageScroll = getPageScroll();
		var lightboxTop = arrayPageScroll[1] + (arrayPageSize[3] / 15);

		Element.setTop('lightbox', lightboxTop);
		Element.show('lightbox');
		this.changeImage(imageNum);
	},

	changeImage : function(imageNum) {

		activeImage = imageNum; // update global var

		Element.show('lb_ld');
		imageDetailsEffect.hide();
		imageEffect.hide();
		navEffect.hide();
		Element.hide('prevLink');
		Element.hide('nextLink');
		var activator_pao = Lightbox.activatedBy.up('.pao_pic');
		if(activator_pao && activator_pao.getAttribute('data-readonly') && activator_pao.getAttribute('data-readonly') == 'readonly' ){
			Element.hide('selectLink');
		}
		else{
			if(activator_pao && activator_pao.getAttribute('data-no_litebox_nav') != 1){
				Element.show('selectLink');
			} else {
				Element.hide('selectLink');
			}
		}
		
		Element.hide('numberDisplay');

		imgPreloader = new Image();

		imgPreloader.onload = function() {
			if(UrlExists(imageArray[activeImage][0]) == true){
				Element.setSrc('lightboxImage', imageArray[activeImage][0]);
			}else{
				Element.setSrc('lightboxImage', noimagefound);
			}
			
			p_wd = imgPreloader.width;
			p_hi = imgPreloader.height;
			p_rat = p_wd/p_hi;
			var arrayPageSize = getPageSize();
			if (p_wd > arrayPageSize[2] - (borderSize*2)) {
				p_wd = arrayPageSize[2] - (borderSize*2);
				p_hi = p_wd / p_rat;
			}
			if (p_hi > arrayPageSize[3] - (borderSize*2) - 120) {
				p_hi = arrayPageSize[3] - (borderSize*2) - 120;
				p_wd = p_hi * p_rat;
			}

			initLightbox.myLightbox.resizeImageContainer(p_wd, p_hi);
		}

		//if(UrlExists(imageArray[activeImage][0]) == true){
			imgPreloader.src = imageArray[activeImage][0];
		/*}else{
			imgPreloader.src = noimagefound;
		}*/
		
	},

	resizeImageContainer : function(imgWidth, imgHeight) {
		this.wCur = Element.getWidth('outerImageContainer');
		this.hCur = Element.getHeight('outerImageContainer');

		wDiff = (this.wCur - borderSize * 2) - imgWidth;
		hDiff = (this.hCur - borderSize * 2) - imgHeight;

		reHeight = new fx.Height('outerImageContainer', {
			duration :resizeDuration
		});
		reHeight.custom(Element.getHeight('outerImageContainer'), imgHeight
				+ (borderSize * 2));
		reWidth = new fx.Width('outerImageContainer', {
			duration :resizeDuration,
			onComplete : function() {
				imageEffect.custom(0, 1);
			}
		});
		reWidth.custom(Element.getWidth('outerImageContainer'), imgWidth
				+ (borderSize * 2));

		if ((hDiff == 0) && (wDiff == 0)) {
			if (navigator.appVersion.indexOf("MSIE") != -1) {
				pause(250);
			} else {
				pause(100);
			}
		}
		Element.setWidth('lightboxImage',imgWidth);
		Element.setHeight('lightboxImage',imgHeight);
		if(Lightbox.activatedBy.up('.pao_pic')){
			Element.setHeight('prevLink', Math.floor(imgHeight * .7));
			Element.setHeight('nextLink', Math.floor(imgHeight * .7));
			Element.setHeight('selectLink', Math.floor(imgHeight * .3) + 11);
		} else {
			Element.setHeight('prevLink', imgHeight);
			Element.setHeight('nextLink', imgHeight);
		}
		Element.setWidth('imageDataContainer', imgWidth + (borderSize * 2));
		Element.setWidth('hoverNav', imgWidth + (borderSize * 2));

		this.showImage();
	},

	showImage : function() {
		Element.hide('lb_ld');
		initLightbox.myLightbox.updateDetails();
		this.preloadNeighborImages();
	},

	updateDetails : function() {

		Element.show('caption');
		Element.setInnerHTML('caption', imageArray[activeImage][1]);

		if (imageArray.length > 1) {
			Element.show('numberDisplay');
			Element.setInnerHTML('numberDisplay', "Image "
					+ eval(activeImage + 1) + " of " + imageArray.length);
		}

		initLightbox.myLightbox.updateNav();
	},

	updateNav : function() {
		
		var activator_pao = Lightbox.activatedBy.up('.pao_pic');

		if (activeImage != 0 && activator_pao && activator_pao.getAttribute('data-no_litebox_nav') != 1) {
			Element.show('prevLink');
			document.getElementById('prevLink').onclick = function() {
				initLightbox.myLightbox.changeImage(activeImage - 1);
				return false;
			}
		}

		if (activeImage != (imageArray.length - 1) && activator_pao && activator_pao.getAttribute('data-no_litebox_nav') != 1) {
			Element.show('nextLink');
			document.getElementById('nextLink').onclick = function() {
				initLightbox.myLightbox.changeImage(activeImage + 1);
				return false;
			}
		}

		$('selectLink').observe('click', function(ev){
			ev.stop();
			if(Lightbox.activatedBy.up('.pao_pic')){
				initLightbox.callback(activeImage, Lightbox.activatedBy, imageArray[activeImage]);
				initLightbox.myLightbox.end();
			}
			order_item_changed('product', Lightbox.activatedBy.up('.product'));
		});

		this.enableKeyboardNav();
	},

	enableKeyboardNav : function() {
		document.observe('keydown', this.keyboardAction);
	},

	disableKeyboardNav : function() {
		document.stopObserving('keydown', this.keyboardAction);
	},

	keyboardAction : function(ev) {
		ev.stop();
		var keycode, key;
		if (Prototype.Browser.IE) {
			keycode = event.keyCode;
		} else { // mozilla
			keycode = ev.which;
		}

		key = String.fromCharCode(keycode).toLowerCase();

		if ("xoc\u00E0".indexOf(key) > -1) { // close lightbox
			initLightbox.myLightbox.end();
		} else if (key == 'p') { // display previous image
			if (activeImage != 0 && Lightbox.litebox_nav_allowed()) {
				initLightbox.myLightbox.disableKeyboardNav();
				initLightbox.myLightbox.changeImage(activeImage - 1);
			}
		} else if (key == 'n') { // display next image
			if (activeImage != (imageArray.length - 1) && Lightbox.litebox_nav_allowed()) {
				initLightbox.myLightbox.disableKeyboardNav();
				initLightbox.myLightbox.changeImage(activeImage + 1);
			}
		} else if (key == 's' && initLightbox.callback && $('selectLink') && $('selectLink').visible()) { // select this image
			initLightbox.callback(activeImage, Lightbox.activatedBy, imageArray[activeImage]);
			initLightbox.myLightbox.end();
		}
	},

	preloadNeighborImages : function() {

		if ((imageArray.length - 1) > activeImage) {
			preloadNextImage = new Image();
			preloadNextImage.src = imageArray[activeImage + 1][0];
		}
		if (activeImage > 0) {
			preloadPrevImage = new Image();
			preloadPrevImage.src = imageArray[activeImage - 1][0];
		}

	},

	end : function() {
		this.disableKeyboardNav();
		Element.hide('lightbox');
		imageEffect.toggle();
		overlayEffect.custom(0.8, 0);
		showSelectBoxes();
	}
}

function getPageScroll() {

	var yScroll;

	if (self.pageYOffset) {
		yScroll = self.pageYOffset;
	} else if (document.documentElement && document.documentElement.scrollTop) { // Explorer
																					// 6
																					// Strict
		yScroll = document.documentElement.scrollTop;
	} else if (document.body) {// all other Explorers
		yScroll = document.body.scrollTop;
	}

	arrayPageScroll = new Array('', yScroll)
	return arrayPageScroll;
}

function getPageSize() {

	var xScroll, yScroll;

	if (window.innerHeight && window.scrollMaxY) {
		xScroll = document.body.scrollWidth;
		yScroll = window.innerHeight + window.scrollMaxY;
	} else if (document.body.scrollHeight > document.body.offsetHeight) { // all
																			// but
																			// Explorer
																			// Mac
		xScroll = document.body.scrollWidth;
		yScroll = document.body.scrollHeight;
	} else { // Explorer Mac...would also work in Explorer 6 Strict, Mozilla
				// and Safari
		xScroll = document.body.offsetWidth;
		yScroll = document.body.offsetHeight;
	}

	var windowWidth, windowHeight;
	if (self.innerHeight) { // all except Explorer
		windowWidth = self.innerWidth;
		windowHeight = self.innerHeight;
	} else if (document.documentElement
			&& document.documentElement.clientHeight) { // Explorer 6 Strict
														// Mode
		windowWidth = document.documentElement.clientWidth;
		windowHeight = document.documentElement.clientHeight;
	} else if (document.body) { // other Explorers
		windowWidth = document.body.clientWidth;
		windowHeight = document.body.clientHeight;
	}

	if (yScroll < windowHeight) {
		pageHeight = windowHeight;
	} else {
		pageHeight = yScroll;
	}

	if (xScroll < windowWidth) {
		pageWidth = windowWidth;
	} else {
		pageWidth = xScroll;
	}

	arrayPageSize = new Array(pageWidth, pageHeight, windowWidth, windowHeight)
	return arrayPageSize;
}

function getKey(e) {
	if (e == null) { // ie
		keycode = event.keyCode;
	} else { // mozilla
		keycode = e.which;
	}
	key = String.fromCharCode(keycode).toLowerCase();
}

function listenKey() {
	document.onkeypress = getKey;
}

function showSelectBoxes() {
	var selects = document.getElementsByTagName("select");
	for (var i = 0; i < selects.length || i > selects.length; i++) {
		selects[i].style.visibility = "visible";
	}
}

function hideSelectBoxes() {
	var selects = document.getElementsByTagName("select");
	for (var i = 0; i < selects.length || i > selects.length; i++) {
		selects[i].style.visibility = "hidden";
	}
}

function pause(numberMillis) {
	var now = new Date();
	var exitTime = now.getTime() + numberMillis;
	while (true) {
		now = new Date();
		if (now.getTime() > exitTime)
			return;
	}
}

function initLightbox(select_callback) {
	initLightbox.callback = select_callback;
	initLightbox.myLightbox = new Lightbox();
}


function UrlExists(url)
{
    var http = new XMLHttpRequest();
	url = !url.includes(site) ? site+url : url;
    http.open('HEAD', url, false);
	try{
		http.send();
		return http.status!=404;
	}catch{
		return http.status!=404;
	}
}